/* eslint-disable import/prefer-default-export */
import type { VariantDisplayType } from 'autogen/swagger/all';
import { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';
import type { ColorStyleProps } from './types';

type SizeValue = {
    width: string | null;
    height: string;
};

type ColorImageSizeValue = {
    width: string;
    height: string;
};

// Attention! These values can only be used for lg-sizes
const DisplayTypeSize: { [key in VariantDisplayType]: key extends 'Text' ? SizeValue : ColorImageSizeValue } = {
    Color: {
        width: '48px',
        height: '48px'
    },
    Image: {
        width: '56px',
        height: '72px'
    },
    Text: {
        width: '100px',
        height: '40px'
    }
};

const baseOutline = css`
    outline: 1px solid ${({ theme }) => theme.ColorBorderPrimary};
    outline-offset: -1px;
`;

function selectedStyling($size: ColorStyleProps['$size']) {
    const borderWidth = $size === 'sm' ? '1px' : '2px';

    return css`
        border: 0;
        outline: ${borderWidth} solid ${({ theme }) => theme.ColorBorderFocusRing};
        outline-offset: -${borderWidth};
    `;
}

function swatchStateStyling($size: ColorStyleProps['$size']) {
    return css`
        &:focus-visible,
        &:active,
        &:hover,
        &:hover:focus {
            text-decoration: none;
            ${selectedStyling($size)}
        }

        ${breakpoint.up(sizes.xl)} {
            &:focus {
                text-decoration: none;
                ${selectedStyling($size)}
            }
        }
    `;
}

export { DisplayTypeSize, swatchStateStyling, selectedStyling, baseOutline };
